
import React, { useEffect, useState } from 'react'
import { withTranslation } from "react-i18next"
import { withRouter, useLocation } from "react-router-dom"
import { DigitalVaultTrackingView } from '../../views'
import { DocumentLogsService, LocalStorageService } from '../../../services'
import { convertToStandarDate } from '../../../utils'
import moment from "moment"

const DigitalVaultTrackingAction = (props) => {
    const { state } = useLocation()

    const [documentLogs, setDocumentLogs] = useState([])
    const [documentLogsFiltered, setDocumentLogsFiltered] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const documentLogsService = new DocumentLogsService(process.env.REACT_APP_MIFIRMA_API)
    const localStorageService = new LocalStorageService()

    const clientId = localStorageService.getLocalStorageItem("user").userMetaData.userA3Cloud.clientId
    const token = localStorageService.getLocalStorageItem("token").idToken
    const timezone = localStorageService.getLocalStorageItem("timezone")
    let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")
    let language = preferredLanguage || "es"
    moment.locale(language)

    const [events, setEvents] = useState([])
    const [companies, setCompanies] = useState([])
    const [selectedCompanyId, setSelectedCompanyId] = useState('0')
    const [selectedLog, setSelectedLog] = useState(null)

    const getAllDocumentLogs = async () => {
        let documentLogs = await documentLogsService.getDocumentLogs(clientId, timezone, token)
        if (documentLogs.statusCode !== 200) {
            console.log("Ha ocurrido un error para obtener las categorías")
            return
        }

        documentLogs.data.documentLogs = documentLogs.data.documentLogs.map(item => {
            if (item?.documentAction?.name) item.documentAction.name = props.t(`digitalVaultStatisticalReportView.key.${item.documentAction.name}`)

            return item
        })
        documentLogs.data.documentActions = documentLogs.data.documentActions.map(item => {
            if (item.name) item.name = props.t(`digitalVaultStatisticalReportView.key.${item.name}`)
            return item
        })

        let filterOptions = []
        setEvents([{ id: 0, name: props.t("digitalVaultTrackingView.combobox.allEvent") }, ...documentLogs.data.documentActions])

        let companyOptions = documentLogs.data.companies
        companyOptions.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
        companyOptions = [{ id: '0', companyName: props.t("digitalVaultTrackingView.combobox.allCompanies") }, ...companyOptions]
        setCompanies(companyOptions)

        for (let i = 0; i < documentLogs.data.documentLogs.length; i++) {
            filterOptions.push({
                id: documentLogs.data.documentLogs[i].id,
                companyId: documentLogs.data.documentLogs[i].document.companyId,
                eventDate: documentLogs.data.documentLogs[i].newDate,
                date: documentLogs.data.documentLogs[i].date,
                documentName: documentLogs.data.documentLogs[i].document.name,
                userName: documentLogs.data.documentLogs[i].user.email,
                eventName: documentLogs.data.documentLogs[i].documentAction?.name,
                eventId: documentLogs.data.documentLogs[i].documentAction?.id,
                documentCompany: documentLogs.data.documentLogs[i].document.companyId,
                activeBtnOne: (documentLogs.data.documentLogs[i].documentAction?.name === process.env.REACT_APP_DOCUMENT_ACTION_DELETE) ? false : true,
                documentId: documentLogs.data.documentLogs[i].documentId
            })
        }

        setIsLoading(false)
        setDocumentLogs(documentLogs)
        setDocumentLogsFiltered(filterOptions)
    }

    useEffect(() => {
        getAllDocumentLogs()

        if (state) {
            setSelectedCompanyId(state.selectedCompanyId)
            setSelectedLog(state.selectedLog)
        }
    }, [])

    return (
        <DigitalVaultTrackingView
            isLoading={isLoading}
            documentLogs={documentLogs}
            documentLogsFiltered={documentLogsFiltered}

            companies={companies}
            selectedCompanyId={selectedCompanyId}
            setSelectedCompanyId={setSelectedCompanyId}

            events={events}
            selectedLog={selectedLog}
            setSelectedLog={setSelectedLog}
        />
    )

}

export default withRouter(withTranslation()(DigitalVaultTrackingAction)) 
